import { render, staticRenderFns } from "./SpecialArea.vue?vue&type=template&id=5365ae41&scoped=true"
import script from "./SpecialArea.vue?vue&type=script&lang=js"
export * from "./SpecialArea.vue?vue&type=script&lang=js"
import style0 from "./SpecialArea.vue?vue&type=style&index=0&id=5365ae41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5365ae41",
  null
  
)

export default component.exports